export const supportedLanguages = ['en', 'en-GB'] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

/** English is the source catalog; every other locale falls back to it per key. */
export const fallbackLanguage: SupportedLanguage = 'en';

/**
 * Canonical supported code for a BCP 47 tag. `en-GB` is both the i18next code
 * and a valid HTML `lang` value, so callers can use the result directly.
 */
export function parseSupportedLanguage(value: string | null | undefined): SupportedLanguage | null {
  if (!value) {
    return null;
  }

  const tag = value.trim().replaceAll('_', '-');

  for (const language of supportedLanguages) {
    if (tag.toLowerCase() === language.toLowerCase()) {
      return language;
    }
  }

  let parsed: Intl.Locale;
  try {
    parsed = new Intl.Locale(tag);
  } catch {
    return null;
  }

  if (parsed.language !== 'en') {
    return null;
  }

  return parsed.region === 'GB' ? 'en-GB' : 'en';
}
